import { PageContent, PageHeader } from '@/components';
import { useCreateBreadcrumbs } from '@/hooks/creaet-breadcrumbs';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderTab } from '../../_components/HeaderTab';
import { useSnapshotTitle } from '../../_hooks/snapshot-title';
import { UsersTable } from '../_components/UsersTable';

export const SnapshotUsersPage: FC = () => {
  const { t } = useTranslation();
  const { title } = useSnapshotTitle();
  const { createBreadcrumb } = useCreateBreadcrumbs({ baseIndex: 3 });
  return (
    <>
      <PageHeader
        title={title}
        breadcrumbs={createBreadcrumb([
          { title: t('tenant-manager-root-page') },
          { title: t('snapshots-name') },
        ])}
      />
      <PageContent>
        <HeaderTab type="users" />
        <UsersTable />
      </PageContent>
    </>
  );
};
